import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  layout: {
    padding: "14px 15px",
    borderRadius: "16px"
  },
  title: {
    fontWeight: "bold",
    fontSize: "14px"
  },
  text: {
    marginLeft: "30px",
    fontSize: "14px"
  },
  icon: {
    width: "20px", 
    marginRight: "10px"
  }
}));

export default useStyles;
